const DataTagihanPembayaran = [
    {
        id: "1",
        jenisPembayaran: "Pendaftaran",
        tagihan: "Rp. 0",
    },
    {
        id: "2",
        jenisPembayaran: "Diklat",
        tagihan: "Rp. 50.000",
    },
    {
        id: "3",
        jenisPembayaran: "Pengukuhan",
        tagihan: "Rp. 100.000",
    },
]

export default DataTagihanPembayaran